import React from "react";
import UlLi, { scrollTo, mountCode} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon} from "react-bootstrap";
import Highlight from "react-highlight";
import { Navigation, Link } from "react-router";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import UserHandler from "js/utilities/user-handler";
import { ZOOM_ICON } from "js/config.jsx";
import SDKSidebar from "js/utilities/sdk-sidebar"

import ZOOM_AUDIT_TRAIL_SWIFT from "resources/code/ios/17-zoom-audit-trail.swift.tpl";
import ZOOM_AUDIT_TRAIL_OBJC from "resources/code/ios/17-zoom-audit-trail.m.tpl";
import AUDIT_TRAIL from "resources/code/android/19-audit-trail.java.tpl"

export default React.createClass({
  scrollToGuide : null,
  scrollingEl: null,

  mixins: [Navigation],

  displayName: "image-guidelines",

  getInitialState() {
    return {
      error: "",
      loading: false,
      complete: false
    };
  },

  componentDidMount: function() {
    this.scrollingEl = document.getElementById("scrollingEl");
    mountCode(this);
    this.scrollToGuide = this.props.location.query.location;
    scrollingEl.scrollTop = 0;
  },

  render: function() {

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container">

              <section id="Overview">
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2>2D Face Image Matching Guidelines</h2>
                </div>
                <p>If you have pre-existing 2D face images that you wish to match to a FaceTec 3D FaceMap with the <code>createFacemapFromImage</code> API, the minimum requirements to be processed are:</p>
                <ul>
                  <li><p>JPG or PNG.</p></li>
                  <li><p>Face has a generally frontal pose.</p></li>
                  <li><p>Face is generally centered in the image.</p></li>
                  <li><p>Face width must be at least 180 pixels wide and ideally should occupy a range between 50% to 80% of the image area.</p></li>
                  <li><p>Face image data must be upright - this is a subtle, but important point. Some JPEGs (depending on device camera) will have the image data in landscape orientation but will use EXIF data to signal to the system to rotate the image.
                    Due to the immense (in)compatibility matrix, we do not parse EXIF data and rely on the application developer to supply and verify the image data submitted is in fact upright.</p></li>
                </ul>
                <p>In general, conformance to <strong>ISO 19794-5 Frontal Face</strong> specifications will yield better performance. These include the following guidelines:</p>
                <ul>
                  <li><p>Neutral expression.</p></li>
                  <li><p>Good, even, ambient lighting.</p></li>
                  <li><p>Evenly lit face, minimizing any shadows and potential glare or reflections in glasses.</p></li>
                  <li><p>High resolution image. A good baseline is around 640x360 portrait, but can be as small as 320 tall and as large as 1920 tall.</p></li>
                </ul>
                <p>Passport photos are a good example on how to follow these guidelines. Although not all photos will comply in every aspect to these recommendations, please keep in mind algorithm performance will vary based on the quality of the image provided.</p>
                <p>For more information or if you have further questions on how to comply to these images requirements, please <Link to="/support" target="_blank">contact us</Link>.</p>
              </section>

              <SDKSidebar menuType="main" title="Image Guidelines"/>

            </div>
          </div>
        </div>
      </div>
    );
  }

});



// WEBPACK FOOTER //
// ./src/js/components/screens/image-guidelines.jsx